import {useEffect, useState} from "react"
import BookStatisticsSummaryResponse from "../responses/BookStatisticsSummaryResponse"
import {BooksitoutServer} from "../../../../config/BooksitoutServer"

const useBookStatisticsSummary = (year: number) => {
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [statistics, setStatistics] = useState<BookStatisticsSummaryResponse | null>(null)

    const DEFAULT = {
        year: year,
        yearStatistics: {
            totalReadTime: 0,
            totalReadBookCount: 0,
            totalReadPage: 0,
            averageStar: 0
        },
        dayStatistics: {
            averageReadTime: 0,
            mostReadTime: 0
        }
    }

    useEffect(() => {
        setIsLoading(true)

        BooksitoutServer
            .get(`/v1/book/statistics/year/${year}`)
            .then((res) => setStatistics(res.data))
            .finally(() => setIsLoading(false))
    }, [year])

    return [statistics ?? DEFAULT, isLoading]
}

export default useBookStatisticsSummary